export function useBlogPostResourceViewer({
  postId,
  resourceId,
}: {
  postId: string;
  resourceId: string;
}) {
  const router = useRouter();
  const route = useRoute();
  const { $analytics } = useNuxtApp();

  const { execute, status } = useAsyncData(
    `blog_post_resource_${resourceId}`,
    async () => {
      router.replace({
        query: {
          ...route.query,
          view_resource: undefined,
        },
      });

      const resource = await $fetch(
        `/api/blog/posts/${postId}/resources/${resourceId}`,
      );

      if (!resource) return;

      $analytics.track("blog_post_resource_viewed");

      if (resource.url) {
        return window.open(resource.url);
      }

      if (!resource.file) return;

      if (resource.allow_download) {
        return window.open(resource.file);
      }

      usePdfViewer().open({
        url: resource.file,
        title: resource.title,
      });
    },
    {
      immediate: false,
    },
  );

  return {
    status,
    view: execute,
  };
}
